module.exports = __webpack_public_path__ + "img/mtt_3.1.d5c87f74.png";